module.exports = __webpack_public_path__ + "img/recommed-img8.fd6781ef.jpg";